/**
 * @module constants
 */

export default {
  DELIVERY_STATUS_COLUMN_WIDTH: '60%',
  MAPS_COLUMN_WIDTH: '25%',
  ORDER_COLUMN_WIDTH: '25%',
};



// WEBPACK FOOTER //
// ./app/constants/deliveryStatusTable.js